import React, { Component } from 'react'
import { withRouter, Switch, Route, Redirect } from 'react-router-dom'

import AppRoute from 'components/AppRoute'

import Auth from 'components/Auth'
import Projects from 'components/Projects'
import Project from 'components/Project'
import ProjectCreator from 'components/ProjectCreator'

class App extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return (
      <Switch>
        <Route path="/auth" component={Auth} />

        <AppRoute path="/projects/create" component={ProjectCreator} withNavigation />
        <AppRoute path="/projects/:projectId" component={Project} />
        <AppRoute path="/projects" component={Projects} withNavigation />

        <Redirect path="/" to="/projects" />
      </Switch>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/components/App/index.js